import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import './index.scss';

import { connect } from 'react-redux';

import Dropdown from '../Dropdown';
import IconButton from '../IconButton';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon/index.js';

const ControlCentersList = ({ t, column, value, controlCenters, onPropChange, item }) => {
  const defaultControlCenter = { controlCenterId: 0, name: '-' };
  const [currentControlCenter, setCurrentControlCenter] = useState(defaultControlCenter);

  const getItems = () => {
    return [defaultControlCenter].concat(
      controlCenters.filter(
        controlCenter => !Array.isArray(value) || !value.find(val => val === controlCenter.controlCenterId)
      )
    );
  };

  const getControlCenterName = controlCenterId => {
    const controlCenter = controlCenters.find(f => f.controlCenterId === controlCenterId) || {};
    return controlCenter.name;
  };

  const handleOnChange = selectedControlCenter => {
    setCurrentControlCenter(selectedControlCenter);
  };

  const handleOnAdd = () => {
    if (value.some(controlCenterId => controlCenterId === currentControlCenter?.controlCenterId)) return;

    if (currentControlCenter && currentControlCenter.controlCenterId && column) {
      const currLength = getItems().length;
      onPropChange && onPropChange({ [column.accessor]: (value || []).concat(currentControlCenter.controlCenterId) });
      if (currLength === 2) {
        setCurrentControlCenter(defaultControlCenter);
      }
    }

    setCurrentControlCenter(defaultControlCenter)
  };

  const handleOnDelete = controlCenterId => {
    if (controlCenterId && column && onPropChange) {
      onPropChange({ [column.accessor]: (value || []).filter(f => f !== controlCenterId) });
    }
  };

  return (
    <div className={classNames('controlCentersList')}>
      <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
      <div className={classNames('controlCentersAddSection')}>
        <Dropdown
          isCanBeEmpty={column?.isCanBeEmpty}
          labelField='name'
          valueField='controlCenterId'
          searchBy='name'
          value={(currentControlCenter || {}).name}
          values={getItems()}
          isRequired={!!column.isRequired}
          isAccentuationByValue={column.isAccentuationByValue}
          readonly={!!column.isReadonly}
          onSelect={handleOnChange}
        />
        <IconButton
          isIcon={true}
          iconName='newOrder'
          tooltipText={column.addTooltip || t('basic.ADD_BUTTON')}
          onClick={handleOnAdd}
        />
      </div>
      <div className={classNames('controlCentersSection')}>
        {(value || []).map(controlCenterId => (
          <div key={controlCenterId} className={classNames('controlCentersSectionItem')}>
            <input
              type='text'
              readOnly={true}
              value={getControlCenterName(controlCenterId)}
              className={classNames('controlCentersSectionItemLabel')}
            />
            <IconButton
              isIcon={true}
              iconName='orderDelete'
              tooltipText={column.deleteTooltip || t('basic.DELETE_BUTTON')}
              onClick={() => handleOnDelete(controlCenterId)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  controlCenters: state.restaurant.data.controlCenters || [],
});

export default connect(mapStateToProps)(withTranslation()(ControlCentersList));
